export const PERSONAL_INFO_UPDATED = 'PersonalInfoUpdated';
export const ADDRESS_BOOK_UPDATED = 'AddressBookUpdated';
export const ADDRESS_BOOK_ADDED = 'AddressBookAdded';
export const ADDRESS_BOOK_DELETED = 'AddressBookDeleted';
export const SHOPPING_PREFERENCES_UPDATED = 'ShoppingPreferencesUpdated';
export const ABANDONED_CART = 'AbandonedCart';
export const PAYMENT_METHOD_UPDATED = 'PaymentMethodUpdated';
export const MY_EQUIPMENT_UPDATE = 'MyEquipmentUpdated';
export const QUOTE_CREATED = 'QuoteCreated';
export const QUOTE_CONVERTED = 'QuoteConverted';
export const QUOTE_DELETED = 'QuoteDeleted';
export const QUOTE_EDITED = 'QuoteEdited';
export const ORDER_CREATED = 'OrderCreated';
export const ORDER_QUEUED = 'OrderQueued';
